/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
  /** The `File` scalar type represents a file upload. */
  File: { input: any; output: any; }
};

/** Describe different king of document */
export enum AccountingDocumentType {
  CreditNote = 'CreditNote',
  Invoice = 'Invoice'
}

/** type of ActiveStorageAttachmentName */
export enum ActiveStorageAttachmentName {
  File = 'File',
  Marker = 'Marker'
}

export type AmountInput = {
  currency: CurrencyGraphQl;
  value: Scalars['Int']['input'];
};

export type AmountObjectType = {
  __typename?: 'AmountObjectType';
  actualExchangeRate: Scalars['Float']['output'];
  amount: Scalars['Int']['output'];
  amountLeft: Scalars['Int']['output'];
};

/** Add comment input */
export type ArchiveCommentInput = {
  archivedAt: Scalars['DateTimeISO']['input'];
  id: Scalars['String']['input'];
};

/** Bank Transfer graphql type */
export type BankTransfer = {
  __typename?: 'BankTransfer';
  id: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  provider?: Maybe<PaymentProvider>;
  sourceAccountId?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** Bed type */
export type BedType = {
  __typename?: 'BedType';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occupancy: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
};

/** Bed type combination item */
export type BedTypeCombinationItem = {
  __typename?: 'BedTypeCombinationItem';
  bedType: BedType;
  count: Scalars['Int']['output'];
  hotelRoomId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BedTypeCombinationItemInput = {
  action?: InputMaybe<PersistenceAction>;
  bedType: BedTypeInput;
  count: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
};

/** Bed type input */
export type BedTypeInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  occupancy: Scalars['Int']['input'];
};

/** Booking type */
export type Booking = GraphQlBooking & {
  __typename?: 'Booking';
  bookingGroup?: Maybe<GraphQlBookingGroup>;
  bookingGroupFull?: Maybe<BookingGroupResponseDto>;
  bookingGroupId?: Maybe<Scalars['String']['output']>;
  bookingPayments?: Maybe<Array<BookingPayment>>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyGraphQl;
  currencyRateId?: Maybe<Scalars['String']['output']>;
  customer: Customer;
  customerId?: Maybe<Scalars['String']['output']>;
  customerOrganizationId?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  events: Array<Event>;
  hotelBooking: HotelBooking;
  id: Scalars['String']['output'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  managedBy?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  paidAmount: Scalars['Int']['output'];
  paidAmountEur: Scalars['Int']['output'];
  payments?: Maybe<Array<Maybe<Payment>>>;
  prices: IndicatorPrices;
  recapEmailSentAt?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BookingStatus>;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  visibility?: Maybe<BookingVisibility>;
};

/** Booking group type */
export type BookingGroup = GraphQlBookingGroup & {
  __typename?: 'BookingGroup';
  name: Scalars['String']['output'];
};

export type BookingGroupEdge = {
  __typename?: 'BookingGroupEdge';
  cursor: Scalars['String']['output'];
  node: PaginatedBookingGroupResponseDto;
};

export type BookingGroupResponseDto = {
  __typename?: 'BookingGroupResponseDto';
  bookings: Array<BookingResponseDto>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency?: Maybe<CurrencyGraphQl>;
  events: Array<Event>;
  hotelContracts: Array<HotelContract>;
  hotels: Array<Hotel>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderItems: Array<OrderItemsResponseDto>;
  owner?: Maybe<User>;
  paidAmount: Scalars['BigInt']['output'];
  paidAmountEur: Scalars['Int']['output'];
  prices?: Maybe<IndicatorPrices>;
  status: BookingStatus;
  token: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Booking payment type */
export type BookingPayment = {
  __typename?: 'BookingPayment';
  bookingId: Scalars['String']['output'];
  category?: Maybe<BookingPaymentCategory>;
  id: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
};

export enum BookingPaymentCategory {
  BookingCanceledPenalty = 'BookingCanceledPenalty',
  DepositAccountCredit = 'DepositAccountCredit',
  OngoingBooking = 'OngoingBooking'
}

export type BookingResponseDto = {
  __typename?: 'BookingResponseDto';
  bookingGroupId?: Maybe<Scalars['String']['output']>;
  bookingPayments?: Maybe<Array<BookingPayment>>;
  checkInDate?: Maybe<Scalars['String']['output']>;
  checkOutDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: Scalars['String']['output'];
  customer?: Maybe<Customer>;
  event?: Maybe<Event>;
  hotelBookings?: Maybe<Array<HotelBooking>>;
  id: Scalars['String']['output'];
  managedBy?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  reference?: Maybe<Scalars['String']['output']>;
  roomingListStatus?: Maybe<RoomingListStatus>;
  status?: Maybe<BookingStatus>;
  totalRoomCount: Scalars['Int']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Describe status of the booking */
export enum BookingStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  Created = 'Created',
  Failed = 'Failed',
  InProgress = 'InProgress',
  PendingConfirm = 'PendingConfirm',
  PendingPayment = 'PendingPayment',
  QuoteRequest = 'QuoteRequest'
}

/** Booking visibility */
export enum BookingVisibility {
  AdminOnly = 'AdminOnly',
  All = 'All'
}

export enum BreakfastOption {
  Included = 'Included',
  NotIncluded = 'NotIncluded',
  Optional = 'Optional'
}

/** cancellation policy graphql type */
export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  penaltyPercentage: Scalars['Float']['output'];
};

/** cancellation policy input type */
export type CancellationPolicyInput = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  penaltyPercentage: Scalars['Float']['input'];
};

export type CommentMentionResponseDto = {
  __typename?: 'CommentMentionResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  seenAt?: Maybe<Scalars['DateTimeISO']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

export type CommentPatch = {
  body: Scalars['String']['input'];
  mentions?: InputMaybe<Mentions>;
};

export type CommentResponseDto = {
  __typename?: 'CommentResponseDto';
  archivedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  body: Scalars['String']['output'];
  commentableId: Scalars['String']['output'];
  commentableType: CommentableType;
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  mentions: Array<CommentMentionResponseDto>;
  updatedAt: Scalars['DateTimeISO']['output'];
  user: User;
  userId: Scalars['String']['output'];
};

/** Commentable type: only HotelContract for now */
export enum CommentableType {
  Booking = 'Booking',
  BookingGroup = 'BookingGroup',
  Customer = 'Customer',
  Event = 'Event',
  Hotel = 'Hotel',
  HotelContract = 'HotelContract',
  Organization = 'Organization',
  Setting = 'Setting',
  Tax = 'Tax'
}

/** IHotelImage */
export type ComputedHotelImage = {
  __typename?: 'ComputedHotelImage';
  isHeroImage: Scalars['Boolean']['output'];
  l: Scalars['String']['output'];
  m: Scalars['String']['output'];
  s: Scalars['String']['output'];
  xl: Scalars['String']['output'];
  xs: Scalars['String']['output'];
};

/** Confirm Booking */
export type ConfirmBookingInput = {
  id: Scalars['String']['input'];
};

/** Confirm Payment Input */
export type ConfirmPaymentInput = {
  amount: Scalars['Int']['input'];
  amountEuro?: InputMaybe<Scalars['Int']['input']>;
  currency: CurrencyGraphQl;
  dueAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  paidAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  paymentId: Scalars['String']['input'];
  paymentMethod: PaymentMethod;
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
  sourceAccountId?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

/** ISO 3166-1 alpha-2 codes are two-letter country codes defined in ISO 3166-1, part of the ISO 3166 standard published by the International Organization for Standardization (ISO), to represent countries, dependent territories, and special areas of geographical interest. They are the most widely used of the country codes published by ISO (the others being alpha-3 and numeric), and are used most prominently for the Internet's country code top-level domains (with a few exceptions). */
export enum CountryIso2Code {
  Ad = 'AD',
  Ae = 'AE',
  Af = 'AF',
  Ag = 'AG',
  Ai = 'AI',
  Al = 'AL',
  Am = 'AM',
  Ao = 'AO',
  Ar = 'AR',
  As = 'AS',
  At = 'AT',
  Au = 'AU',
  Aw = 'AW',
  Ax = 'AX',
  Az = 'AZ',
  Ba = 'BA',
  Bb = 'BB',
  Bd = 'BD',
  Be = 'BE',
  Bf = 'BF',
  Bg = 'BG',
  Bh = 'BH',
  Bi = 'BI',
  Bj = 'BJ',
  Bl = 'BL',
  Bm = 'BM',
  Bn = 'BN',
  Bo = 'BO',
  Bq = 'BQ',
  Br = 'BR',
  Bs = 'BS',
  Bt = 'BT',
  Bw = 'BW',
  By = 'BY',
  Bz = 'BZ',
  Ca = 'CA',
  Cc = 'CC',
  Cd = 'CD',
  Cf = 'CF',
  Cg = 'CG',
  Ch = 'CH',
  Ci = 'CI',
  Ck = 'CK',
  Cl = 'CL',
  Cm = 'CM',
  Cn = 'CN',
  Co = 'CO',
  Cr = 'CR',
  Cu = 'CU',
  Cv = 'CV',
  Cw = 'CW',
  Cx = 'CX',
  Cy = 'CY',
  Cz = 'CZ',
  De = 'DE',
  Dj = 'DJ',
  Dk = 'DK',
  Dm = 'DM',
  Do = 'DO',
  Dz = 'DZ',
  Ec = 'EC',
  Ee = 'EE',
  Eg = 'EG',
  Eh = 'EH',
  Er = 'ER',
  Es = 'ES',
  Et = 'ET',
  Fi = 'FI',
  Fj = 'FJ',
  Fk = 'FK',
  Fm = 'FM',
  Fo = 'FO',
  Fr = 'FR',
  Ga = 'GA',
  Gb = 'GB',
  Gd = 'GD',
  Ge = 'GE',
  Gf = 'GF',
  Gg = 'GG',
  Gh = 'GH',
  Gi = 'GI',
  Gl = 'GL',
  Gm = 'GM',
  Gn = 'GN',
  Gp = 'GP',
  Gq = 'GQ',
  Gr = 'GR',
  Gt = 'GT',
  Gu = 'GU',
  Gw = 'GW',
  Gy = 'GY',
  Hk = 'HK',
  Hn = 'HN',
  Hr = 'HR',
  Ht = 'HT',
  Hu = 'HU',
  Id = 'ID',
  Ie = 'IE',
  Il = 'IL',
  Im = 'IM',
  In = 'IN',
  Io = 'IO',
  Iq = 'IQ',
  Ir = 'IR',
  Is = 'IS',
  It = 'IT',
  Je = 'JE',
  Jm = 'JM',
  Jo = 'JO',
  Jp = 'JP',
  Ke = 'KE',
  Kg = 'KG',
  Kh = 'KH',
  Ki = 'KI',
  Km = 'KM',
  Kn = 'KN',
  Kp = 'KP',
  Kr = 'KR',
  Kw = 'KW',
  Ky = 'KY',
  Kz = 'KZ',
  La = 'LA',
  Lb = 'LB',
  Lc = 'LC',
  Li = 'LI',
  Lk = 'LK',
  Lr = 'LR',
  Ls = 'LS',
  Lt = 'LT',
  Lu = 'LU',
  Lv = 'LV',
  Ly = 'LY',
  Ma = 'MA',
  Mc = 'MC',
  Md = 'MD',
  Me = 'ME',
  Mf = 'MF',
  Mg = 'MG',
  Mh = 'MH',
  Mk = 'MK',
  Ml = 'ML',
  Mm = 'MM',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Mq = 'MQ',
  Mr = 'MR',
  Ms = 'MS',
  Mt = 'MT',
  Mu = 'MU',
  Mv = 'MV',
  Mw = 'MW',
  Mx = 'MX',
  My = 'MY',
  Mz = 'MZ',
  Na = 'NA',
  Nc = 'NC',
  Ne = 'NE',
  Nf = 'NF',
  Ng = 'NG',
  Ni = 'NI',
  Nl = 'NL',
  No = 'NO',
  Np = 'NP',
  Nr = 'NR',
  Nu = 'NU',
  Nz = 'NZ',
  Om = 'OM',
  Pa = 'PA',
  Pe = 'PE',
  Pf = 'PF',
  Pg = 'PG',
  Ph = 'PH',
  Pk = 'PK',
  Pl = 'PL',
  Pm = 'PM',
  Pr = 'PR',
  Ps = 'PS',
  Pt = 'PT',
  Pw = 'PW',
  Py = 'PY',
  Qa = 'QA',
  Re = 'RE',
  Ro = 'RO',
  Rs = 'RS',
  Ru = 'RU',
  Rw = 'RW',
  Sa = 'SA',
  Sb = 'SB',
  Sc = 'SC',
  Sd = 'SD',
  Se = 'SE',
  Sg = 'SG',
  Sh = 'SH',
  Si = 'SI',
  Sj = 'SJ',
  Sk = 'SK',
  Sl = 'SL',
  Sm = 'SM',
  Sn = 'SN',
  So = 'SO',
  Sr = 'SR',
  Ss = 'SS',
  St = 'ST',
  Sv = 'SV',
  Sx = 'SX',
  Sy = 'SY',
  Sz = 'SZ',
  Tc = 'TC',
  Td = 'TD',
  Tg = 'TG',
  Th = 'TH',
  Tj = 'TJ',
  Tk = 'TK',
  Tl = 'TL',
  Tm = 'TM',
  Tn = 'TN',
  To = 'TO',
  Tr = 'TR',
  Tt = 'TT',
  Tv = 'TV',
  Tw = 'TW',
  Tz = 'TZ',
  Ua = 'UA',
  Ug = 'UG',
  Us = 'US',
  Uy = 'UY',
  Uz = 'UZ',
  Va = 'VA',
  Vc = 'VC',
  Ve = 'VE',
  Vg = 'VG',
  Vi = 'VI',
  Vn = 'VN',
  Vu = 'VU',
  Wf = 'WF',
  Ws = 'WS',
  Xk = 'XK',
  Ye = 'YE',
  Yt = 'YT',
  Za = 'ZA',
  Zm = 'ZM',
  Zw = 'ZW'
}

/** Coupon type */
export type Coupon = {
  __typename?: 'Coupon';
  amount: Scalars['Int']['output'];
  bookingId?: Maybe<Scalars['String']['output']>;
  currency: CurrencyGraphQl;
  endAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startAt: Scalars['DateTimeISO']['output'];
};

/** coupon payment graphql type */
export type CouponPayment = {
  __typename?: 'CouponPayment';
  couponId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
};

/** Add comment input */
export type CreateCommentInput = {
  authorId: Scalars['String']['input'];
  body: Scalars['String']['input'];
  commentableId: Scalars['String']['input'];
  commentableType: CommentableType;
  mentions?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Generates a coupon */
export type CreateCouponInput = {
  bookingId: Scalars['String']['input'];
  cancelSupplierBooking?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
  forcedPenaltyPercentage?: InputMaybe<Scalars['Int']['input']>;
  generateCoupon?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTimeISO']['input']>;
};

export type CreateHotelContractFinancialInput = {
  comissionsAmount?: InputMaybe<Scalars['Float']['input']>;
  currency: CurrencyGraphQl;
  hotelContractId: Scalars['String']['input'];
  purchasedAmount?: InputMaybe<Scalars['Float']['input']>;
  vatComissionsAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** Create Hotel Contracts */
export type CreateHotelContractInput = {
  currency: CurrencyGraphQl;
  hotelId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateHotelInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<HotelAmenityType>>;
  checkInTime?: InputMaybe<Scalars['String']['input']>;
  checkOutTime?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryIso2Code>;
  expediaId?: InputMaybe<Scalars['String']['input']>;
  hotelTranslations: Array<HotelTranslationInput>;
  imageSource?: InputMaybe<SourceHotelRoom>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrderItemInput = {
  orderId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type CreatePaymentInput = {
  amount: Scalars['Int']['input'];
  amountEuro?: InputMaybe<Scalars['Int']['input']>;
  currency: CurrencyGraphQl;
  dueAt?: InputMaybe<Scalars['String']['input']>;
  paidAt?: InputMaybe<Scalars['String']['input']>;
  paymentCategory?: InputMaybe<HotelContractPaymentCategory>;
  paymentMethod: PaymentMethod;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType: PaymentType;
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
  sourceAccountId?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentResponseDto = {
  __typename?: 'CreatePaymentResponseDto';
  actualExchangeRate?: Maybe<Scalars['Float']['output']>;
  amount: Scalars['Float']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyGraphQl;
  currencyRateId?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTimeISO']['output']>;
  paymentMethod: PaymentMethod;
  paymentStatus: PaymentStatus;
  paymentType: PaymentType;
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** Create File Input */
export type CreateProductFileInput = {
  files: Array<Scalars['File']['input']>;
  recordId: Scalars['String']['input'];
  recordType: RecordType;
};

/** Create Product Input */
export type CreateProductInput = {
  buyCurrency: CurrencyGraphQl;
  buyPrice: Scalars['Int']['input'];
  buyPriceEur: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name: Scalars['String']['input'];
  productTypeId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  sellCurrency: CurrencyGraphQl;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  taxIncludedSellPrice: Scalars['Int']['input'];
};

/** Create Product Type Input */
export type CreateProductTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateTaxInput = {
  amount?: InputMaybe<AmountInput>;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  name: Scalars['String']['input'];
  percentage?: InputMaybe<Scalars['Float']['input']>;
  taxFrequency: TaxFrequency;
  taxMode: TaxMode;
};

export enum CurrencyGraphQl {
  Aed = 'AED',
  Afn = 'AFN',
  All = 'ALL',
  Amd = 'AMD',
  Ang = 'ANG',
  Aoa = 'AOA',
  Ars = 'ARS',
  Aud = 'AUD',
  Awg = 'AWG',
  Azn = 'AZN',
  Bam = 'BAM',
  Bbd = 'BBD',
  Bdt = 'BDT',
  Bgn = 'BGN',
  Bhd = 'BHD',
  Bif = 'BIF',
  Bmd = 'BMD',
  Bnd = 'BND',
  Bob = 'BOB',
  Brl = 'BRL',
  Bsd = 'BSD',
  Btn = 'BTN',
  Bwp = 'BWP',
  Byn = 'BYN',
  Byr = 'BYR',
  Bzd = 'BZD',
  Cad = 'CAD',
  Cdf = 'CDF',
  Chf = 'CHF',
  Clf = 'CLF',
  Clp = 'CLP',
  Cny = 'CNY',
  Cop = 'COP',
  Crc = 'CRC',
  Cuc = 'CUC',
  Cup = 'CUP',
  Cve = 'CVE',
  Czk = 'CZK',
  Djf = 'DJF',
  Dkk = 'DKK',
  Dop = 'DOP',
  Dzd = 'DZD',
  Eek = 'EEK',
  Egp = 'EGP',
  Ern = 'ERN',
  Etb = 'ETB',
  Eur = 'EUR',
  Fjd = 'FJD',
  Fkp = 'FKP',
  Gbp = 'GBP',
  Gel = 'GEL',
  Ghs = 'GHS',
  Gip = 'GIP',
  Gmd = 'GMD',
  Gnf = 'GNF',
  Gtq = 'GTQ',
  Gyd = 'GYD',
  Hkd = 'HKD',
  Hnl = 'HNL',
  Hrk = 'HRK',
  Htg = 'HTG',
  Huf = 'HUF',
  Idr = 'IDR',
  Ils = 'ILS',
  Inr = 'INR',
  Iqd = 'IQD',
  Irr = 'IRR',
  Isk = 'ISK',
  Jmd = 'JMD',
  Jod = 'JOD',
  Jpy = 'JPY',
  Kes = 'KES',
  Kgs = 'KGS',
  Khr = 'KHR',
  Kmf = 'KMF',
  Kpw = 'KPW',
  Krw = 'KRW',
  Kwd = 'KWD',
  Kyd = 'KYD',
  Kzt = 'KZT',
  Lak = 'LAK',
  Lbp = 'LBP',
  Lkr = 'LKR',
  Lrd = 'LRD',
  Lsl = 'LSL',
  Ltl = 'LTL',
  Lvl = 'LVL',
  Lyd = 'LYD',
  Mad = 'MAD',
  Mdl = 'MDL',
  Mga = 'MGA',
  Mkd = 'MKD',
  Mmk = 'MMK',
  Mnt = 'MNT',
  Mop = 'MOP',
  Mro = 'MRO',
  Mur = 'MUR',
  Mvr = 'MVR',
  Mwk = 'MWK',
  Mxn = 'MXN',
  Myr = 'MYR',
  Mzn = 'MZN',
  Nad = 'NAD',
  Ngn = 'NGN',
  Nio = 'NIO',
  Nok = 'NOK',
  Npr = 'NPR',
  Nzd = 'NZD',
  Omr = 'OMR',
  Pab = 'PAB',
  Pen = 'PEN',
  Pgk = 'PGK',
  Php = 'PHP',
  Pkr = 'PKR',
  Pln = 'PLN',
  Pyg = 'PYG',
  Qar = 'QAR',
  Ron = 'RON',
  Rsd = 'RSD',
  Rub = 'RUB',
  Rwf = 'RWF',
  Sar = 'SAR',
  Sbd = 'SBD',
  Scr = 'SCR',
  Sdg = 'SDG',
  Sek = 'SEK',
  Sgd = 'SGD',
  Shp = 'SHP',
  Sll = 'SLL',
  Sos = 'SOS',
  Srd = 'SRD',
  Ssp = 'SSP',
  Std = 'STD',
  Syp = 'SYP',
  Szl = 'SZL',
  Thb = 'THB',
  Tjs = 'TJS',
  Tmt = 'TMT',
  Tnd = 'TND',
  Top = 'TOP',
  Try = 'TRY',
  Ttd = 'TTD',
  Twd = 'TWD',
  Tzs = 'TZS',
  Uah = 'UAH',
  Ugx = 'UGX',
  Usd = 'USD',
  Uyu = 'UYU',
  Uzs = 'UZS',
  Vef = 'VEF',
  Vnd = 'VND',
  Vuv = 'VUV',
  Wst = 'WST',
  Xaf = 'XAF',
  Xcd = 'XCD',
  Xof = 'XOF',
  Xpf = 'XPF',
  Yer = 'YER',
  Zar = 'ZAR',
  Zmk = 'ZMK',
  Zmw = 'ZMW',
  Zwl = 'ZWL'
}

/** Customer graphql type */
export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Scalars['String']['output']>;
  bookingId?: Maybe<Scalars['String']['output']>;
  bookings: Array<HotelBookingTrait>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  fullname: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lang: Locale;
  lastName: Scalars['String']['output'];
  locale: Lang;
  nationality: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CustomerResponseDto = {
  __typename?: 'CustomerResponseDto';
  address?: Maybe<Scalars['String']['output']>;
  bookingId?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lang: Locale;
  lastName: Scalars['String']['output'];
  locale?: Maybe<Lang>;
  nationality: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  salutation?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** Delete Payment Input */
export type DeleteHotelContractPaymentInput = {
  hotelContractId: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
};

/** Delete Payment Input */
export type DeletePaymentInput = {
  paymentId: Scalars['String']['input'];
  paymentMethod: PaymentMethod;
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
};

/** Delete Product File Input */
export type DeleteProductFileInput = {
  blobId: Scalars['Int']['input'];
};

export type DocumentResponseDto = {
  __typename?: 'DocumentResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyGraphQl;
  customerId: Scalars['String']['output'];
  documentLink: Scalars['String']['output'];
  documentNumber: Scalars['String']['output'];
  documentProvider: Scalars['String']['output'];
  documentProviderId: Scalars['String']['output'];
  documentType: AccountingDocumentType;
  exchangeRate?: Maybe<Scalars['Float']['output']>;
  resourceId: Scalars['String']['output'];
  resourceType: PaymentAssociationResourceType;
  totalTaxExclAmount: Scalars['Int']['output'];
  totalTaxInclAmount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Add HotelContractPayment and payment */
export type EditHotelContractPaymentInput = {
  amount: Scalars['Int']['input'];
  amountEur?: InputMaybe<Scalars['Int']['input']>;
  category: HotelContractPaymentCategory;
  currency: CurrencyGraphQl;
  hotelContractId: Scalars['String']['input'];
  paidAt: Scalars['DateTimeISO']['input'];
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentType: PaymentType;
  sourceAccountId?: InputMaybe<Scalars['String']['input']>;
  sourceId: Scalars['String']['input'];
};

/** Edit loyalty points reward status input type */
export type EditLoyaltyRewardStatus = {
  id: Scalars['String']['input'];
  status: LoyaltyRewardStatus;
};

/** Edit Payment Input */
export type EditPaymentInput = {
  id: Scalars['String']['input'];
  patch: CreatePaymentInput;
};

export type EditProductInput = {
  id: Scalars['String']['input'];
  patch: EditProductPatch;
};

export type EditProductPatch = {
  buyCurrency?: InputMaybe<CurrencyGraphQl>;
  buyPrice?: InputMaybe<Scalars['Int']['input']>;
  buyPriceEur?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productTypeId: Scalars['String']['input'];
  remarks?: InputMaybe<Scalars['String']['input']>;
  sellCurrency?: InputMaybe<CurrencyGraphQl>;
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>;
  taxIncludedSellPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** Event */
export type Event = {
  __typename?: 'Event';
  bookings: Array<HotelBookingTrait>;
  checkInDate?: Maybe<Scalars['DateTimeISO']['output']>;
  checkOutDate?: Maybe<Scalars['DateTimeISO']['output']>;
  eventDateFrom?: Maybe<Scalars['DateTimeISO']['output']>;
  eventDateTo?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  logoPicture?: Maybe<Scalars['String']['output']>;
  markerPicture?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  venueDescription?: Maybe<Scalars['String']['output']>;
  venueName?: Maybe<Scalars['String']['output']>;
};

/** Event graphql input type */
export type EventInput = {
  eventDateFrom?: InputMaybe<Scalars['DateTimeISO']['input']>;
  eventDateTo?: InputMaybe<Scalars['DateTimeISO']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type FileResponseDto = {
  __typename?: 'FileResponseDto';
  attachmentType: ActiveStorageAttachmentName;
  blobId: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  previewUrl: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type GetBookingEdgeDto = {
  __typename?: 'GetBookingEdgeDto';
  cursor: Scalars['String']['output'];
  node: Booking;
};

/** Paginated Booking Groups args */
export type GetBookingGroupsPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

export type GetBookingsPaginatedOptions = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  customerQuery?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<BookingStatus>>;
};

export type GetBookingsPaginatedResponseDto = {
  __typename?: 'GetBookingsPaginatedResponseDto';
  edges: Array<GetBookingEdgeDto>;
  pageInfo: GraphQlPaginationPageInfo;
};

/** Get Hotel Contracts */
export type GetHotelContractsInput = {
  hotelId?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Get Hotel Contracts Paginated */
export type GetHotelContractsPaginatedInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<CurrencyGraphQl>;
  eventQuery?: InputMaybe<Scalars['String']['input']>;
  hotelQuery?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  loyaltyRewardStatus?: InputMaybe<Array<LoyaltyRewardStatus>>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<HotelContractStatus>>;
  userQuery?: InputMaybe<Scalars['String']['input']>;
};

/** Paginated Taxes Options */
export type GetTaxesPaginatedOptions = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Order>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** File upload status type */
export type GraphFileUploadStatus = {
  __typename?: 'GraphFileUploadStatus';
  filename: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  uploaded: Scalars['Boolean']['output'];
};

/** Bed */
export type GraphQlBed = {
  __typename?: 'GraphQLBed';
  /** Number of beds */
  count: Scalars['Int']['output'];
  /** Bed name */
  name: Scalars['String']['output'];
  /** Bed's Occupancy */
  occupancy: Scalars['Int']['output'];
};

export type GraphQlBooking = {
  bookingGroup?: Maybe<GraphQlBookingGroup>;
  bookingGroupId?: Maybe<Scalars['String']['output']>;
  bookingPayments?: Maybe<Array<BookingPayment>>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyGraphQl;
  currencyRateId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerOrganizationId?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  managedBy?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  recapEmailSentAt?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BookingStatus>;
  updatedAt: Scalars['DateTimeISO']['output'];
  visibility?: Maybe<BookingVisibility>;
};

export type GraphQlBookingGroup = {
  name: Scalars['String']['output'];
};

/** Computed Hotel Room */
export type GraphQlComputedHotelRoom = {
  __typename?: 'GraphQLComputedHotelRoom';
  /** Amenities */
  amenities: Scalars['String']['output'];
  /** Beds */
  beds: Array<Array<GraphQlBed>>;
  /** Beds pretty */
  bedsPretty: Scalars['String']['output'];
  /** Cancellation policies */
  cancellationPolicies: Array<CancellationPolicy>;
  /** Number of rooms */
  count: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  food: Scalars['Int']['output'];
  highresImages: Scalars['Boolean']['output'];
  hotelId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageIndexes: Array<Scalars['Int']['output']>;
  lowresImages: Scalars['Boolean']['output'];
  occupancy: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  richDescription?: Maybe<Scalars['String']['output']>;
  roomSquareFeet?: Maybe<Scalars['Int']['output']>;
  roomSquareMeter?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  taxes: Array<Tax>;
  thumbImages?: Maybe<Scalars['Boolean']['output']>;
};

/** Expedia Formatted Hotel */
export type GraphQlExpediaFormattedHotel = {
  __typename?: 'GraphQLExpediaFormattedHotel';
  hotel: Hotel;
  hotelTranslations: Array<HotelTranslation>;
};

/** Expedia Hotel */
export type GraphQlExpediaHotel = {
  __typename?: 'GraphQLExpediaHotel';
  _id: Scalars['String']['output'];
  formatted: GraphQlExpediaFormattedHotel;
  images: Array<ComputedHotelImage>;
};

/** Hotel room offer */
export type GraphQlHotelRoomOffer = {
  __typename?: 'GraphQLHotelRoomOffer';
  /** Number of breakfasts included in the price */
  breakfastCount: Scalars['Int']['output'];
  /** Breakfast option */
  breakfastOption: BreakfastOption;
  /** Breakfast price per guest per night */
  breakfastPricePerGuestPerNight: Scalars['Int']['output'];
  /** Cancellation policies */
  cancellationPolicies: Array<CancellationPolicy>;
  /** Number of rooms */
  count: Scalars['Int']['output'];
  /** Creation date */
  createdAt: Scalars['DateTimeISO']['output'];
  /** Currency */
  currency: CurrencyGraphQl;
  /** Hotel ID */
  hotelId: Scalars['String']['output'];
  /** Hotel room offer request ID */
  hotelRoomOfferRequestId: Scalars['String']['output'];
  /** Hotel rooms */
  hotelRooms: Array<GraphQlComputedHotelRoom>;
  /** Hotel room offer ID */
  id: Scalars['String']['output'];
  /** Is gone */
  isGone: Scalars['Boolean']['output'];
  /** Package type */
  packageType: PackageType;
  /** Price */
  price: Scalars['Int']['output'];
  /** Provider */
  provider: Provider;
  /** Provider hash */
  providerHash: Scalars['String']['output'];
  /** Source market */
  sourceMarket: CountryIso2Code;
  /** Tags */
  tags: Array<Tag>;
  /** Tax included price */
  taxIncludedPrice: Scalars['Int']['output'];
  taxes: Array<Tax>;
  /** T */
  type: HotelRoomOfferType;
};

export type GraphQlPaginationPageInfo = {
  __typename?: 'GraphQLPaginationPageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
  totalCount?: Maybe<Scalars['Float']['output']>;
};

/** Hotel type */
export type Hotel = {
  __typename?: 'Hotel';
  address?: Maybe<Scalars['String']['output']>;
  amenities: Array<HotelAmenityType>;
  checkInTime?: Maybe<Scalars['String']['output']>;
  checkOutTime?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode: CountryIso2Code;
  currency: CurrencyGraphQl;
  email?: Maybe<Scalars['String']['output']>;
  expediaId?: Maybe<Scalars['String']['output']>;
  hotelImages: Array<ComputedHotelImage>;
  hotelTranslations: Array<Maybe<HotelTranslation>>;
  id: Scalars['String']['output'];
  imageSource?: Maybe<SourceHotelRoom>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isOnline: Scalars['Boolean']['output'];
  lastRakutenActiveAt?: Maybe<Scalars['DateTimeISO']['output']>;
  latitude: Scalars['Float']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  reviewRating?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  taxes: Array<Tax>;
  timezone?: Maybe<Scalars['String']['output']>;
  updateHotelEvent?: Maybe<UpdateHotelEvent>;
};


/** Hotel type */
export type HotelHotelImagesArgs = {
  source?: InputMaybe<SourceHotelRoom>;
};

/** Hotel amenity type */
export enum HotelAmenityType {
  AirConditioning = 'AirConditioning',
  AirportTransportation = 'AirportTransportation',
  BusinessCenter = 'BusinessCenter',
  CarRentDesk = 'CarRentDesk',
  ChildrenAllowed = 'ChildrenAllowed',
  ClothingIron = 'ClothingIron',
  CoffeeTeaMaker = 'CoffeeTeaMaker',
  Combination = 'Combination',
  ContinentalBreakfast = 'ContinentalBreakfast',
  DataPorts = 'DataPorts',
  DryCleaning = 'DryCleaning',
  ElectronicRoomKeys = 'ElectronicRoomKeys',
  ExteriorRoomEntrance = 'ExteriorRoomEntrance',
  FamilyRooms = 'FamilyRooms',
  FitnessFacility = 'FitnessFacility',
  GameRoom = 'GameRoom',
  GolfCourse = 'GolfCourse',
  HairDryer = 'HairDryer',
  HandicapAccessible = 'HandicapAccessible',
  InHouseBar = 'InHouseBar',
  InHouseDining = 'InHouseDining',
  InRoomMovies = 'InRoomMovies',
  IndoorPool = 'IndoorPool',
  InteriorRoomEntrance = 'InteriorRoomEntrance',
  Kitchen = 'Kitchen',
  Map = 'Map',
  MeetingRooms = 'MeetingRooms',
  MiniBarInRoom = 'MiniBarInRoom',
  NonSmokingRooms = 'NonSmokingRooms',
  OutdoorPool = 'OutdoorPool',
  ParkingGarage = 'ParkingGarage',
  PetsAllowed = 'PetsAllowed',
  RestrictedAccess = 'RestrictedAccess',
  RoomService = 'RoomService',
  Safe = 'Safe',
  Sauna = 'Sauna',
  TvInRoom = 'TVInRoom',
  TennisCourt = 'TennisCourt',
  TwentyFourHourSecurity = 'TwentyFourHourSecurity',
  ValetParking = 'ValetParking',
  VideoCheckOut = 'VideoCheckOut',
  VoiceMail = 'VoiceMail',
  WakeUpService = 'WakeUpService',
  Whirpool = 'Whirpool'
}

/** Hotel booking type */
export type HotelBooking = {
  __typename?: 'HotelBooking';
  adultCount: Scalars['Int']['output'];
  booking?: Maybe<GraphQlBooking>;
  bookingId: Scalars['String']['output'];
  breakfastCount?: Maybe<Scalars['Int']['output']>;
  breakfastOriginalPrice?: Maybe<Scalars['Float']['output']>;
  breakfastPrice?: Maybe<Scalars['Float']['output']>;
  breakfastRetrocommission?: Maybe<Scalars['Int']['output']>;
  canceledAt?: Maybe<Scalars['DateTimeISO']['output']>;
  cancellationPolicies: Array<CancellationPolicy>;
  cancellationPolicyRemarks?: Maybe<Scalars['String']['output']>;
  checkInDate: Scalars['String']['output'];
  checkOutDate: Scalars['String']['output'];
  children?: Maybe<Scalars['String']['output']>;
  confirmedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  correctedProviderSellingPrice?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  customerReference?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  hotel: Hotel;
  hotelContract?: Maybe<HotelContract>;
  hotelId: Scalars['String']['output'];
  hotelRoomOffer?: Maybe<GraphQlHotelRoomOffer>;
  hotelRoomStockBookings?: Maybe<Array<HotelRoomStockBooking>>;
  hotelRoomingLists?: Maybe<Array<HotelRoomingList>>;
  id: Scalars['String']['output'];
  penaltyPercentage?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  priceFull: Scalars['Int']['output'];
  provider: Provider;
  providerBookingId?: Maybe<Scalars['String']['output']>;
  providerConfirmedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  providerCurrency?: Maybe<CurrencyGraphQl>;
  providerSellingPrice?: Maybe<Scalars['Int']['output']>;
  releaseDate?: Maybe<Scalars['DateTimeISO']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  roomCount?: Maybe<Scalars['Int']['output']>;
  roomRetrocommission?: Maybe<Scalars['Int']['output']>;
  sourceMarket: CountryIso2Code;
  status: BookingStatus;
  taxAmount?: Maybe<Scalars['Int']['output']>;
  taxIncludedPrice?: Maybe<Scalars['Int']['output']>;
  taxes?: Maybe<Array<Tax>>;
};

export type HotelBookingTrait = {
  __typename?: 'HotelBookingTrait';
  bookingGroup?: Maybe<GraphQlBookingGroup>;
  bookingGroupId?: Maybe<Scalars['String']['output']>;
  bookingPayments?: Maybe<Array<BookingPayment>>;
  comments?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyGraphQl;
  currencyRateId?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<Customer>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerOrganizationId?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  hotelBooking: HotelBooking;
  id: Scalars['String']['output'];
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  managedBy?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  recapEmailSentAt?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<BookingStatus>;
  updatedAt: Scalars['DateTimeISO']['output'];
  visibility?: Maybe<BookingVisibility>;
};

/** Hotel contract type */
export type HotelContract = {
  __typename?: 'HotelContract';
  bookings: Array<Booking>;
  checkInDates: Array<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  currency: CurrencyGraphQl;
  events: Array<Event>;
  files?: Maybe<Array<HotelContractFilesWithInformations>>;
  forcedTotalComissionsAmount?: Maybe<Scalars['BigInt']['output']>;
  forcedTotalPurchasedAmount?: Maybe<Scalars['BigInt']['output']>;
  forcedTotalVatComissionsAmount?: Maybe<Scalars['BigInt']['output']>;
  hotel?: Maybe<Hotel>;
  hotelContractFiles?: Maybe<Array<HotelContractFile>>;
  hotelContractFinancials: Array<HotelContractFinancial>;
  hotelContractPayments?: Maybe<Array<HotelContractPayment>>;
  hotelId: Scalars['String']['output'];
  hotelRoomStocks?: Maybe<Array<HotelRoomStock>>;
  hotelRooms: Array<HotelRoom>;
  id: Scalars['String']['output'];
  indicators: HotelContractIndicators;
  loyaltyRewardStatus: LoyaltyRewardStatus;
  name: Scalars['String']['output'];
  releaseDates: Array<Scalars['String']['output']>;
  status: HotelContractStatus;
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
};

export type HotelContractEdge = {
  __typename?: 'HotelContractEdge';
  cursor: Scalars['String']['output'];
  node: HotelContract;
};

/** Hotel contract file type */
export type HotelContractFile = {
  __typename?: 'HotelContractFile';
  category: HotelContractFileCategory;
  hotelContractId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Type of HotelContractFileCategory */
export enum HotelContractFileCategory {
  CommissionInvoice = 'CommissionInvoice',
  Contract = 'Contract',
  Invoice = 'Invoice',
  Other = 'Other',
  Proforma = 'Proforma'
}

/** UploadFile input type */
export type HotelContractFileUploadInput = {
  category: HotelContractFileCategory;
  files: Array<Scalars['File']['input']>;
  hotelContractId: Scalars['String']['input'];
};

/** HotelContractFile type */
export type HotelContractFilesWithInformations = {
  __typename?: 'HotelContractFilesWithInformations';
  attachmentType: ActiveStorageAttachmentName;
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  hotelContractFileCategory?: Maybe<HotelContractFileCategory>;
  metadata?: Maybe<Scalars['String']['output']>;
  previewUrl: Scalars['String']['output'];
  recordId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Hotel Contract Financial */
export type HotelContractFinancial = {
  __typename?: 'HotelContractFinancial';
  comissionsAmount?: Maybe<Scalars['BigInt']['output']>;
  currency: CurrencyGraphQl;
  hotelContractId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  purchasedAmount?: Maybe<Scalars['BigInt']['output']>;
  vatComissionsAmount?: Maybe<Scalars['BigInt']['output']>;
};

/** HotelContractIndicators type */
export type HotelContractFinancialIndicators = {
  __typename?: 'HotelContractFinancialIndicators';
  comissionsAmount: Scalars['BigInt']['output'];
  currency: CurrencyGraphQl;
  paidAmount: Scalars['BigInt']['output'];
  purchasedAmount: Scalars['BigInt']['output'];
  receivedAmount: Scalars['BigInt']['output'];
};

/** HotelContractIndicators type */
export type HotelContractIndicators = {
  __typename?: 'HotelContractIndicators';
  blockedStock: Scalars['Int']['output'];
  financialIndicators: Array<HotelContractFinancialIndicators>;
  margin: Scalars['Float']['output'];
  marginPercentage: Scalars['Float']['output'];
  soldStock: Scalars['Int']['output'];
  totalCommission: Scalars['Int']['output'];
  totalPurchased: Scalars['BigInt']['output'];
  totalSale: Scalars['Int']['output'];
  totalStock: Scalars['Int']['output'];
};

/** Hotel contract payment type */
export type HotelContractPayment = {
  __typename?: 'HotelContractPayment';
  category?: Maybe<HotelContractPaymentCategory>;
  hotelContractId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  payment: Payment;
  paymentId: Scalars['String']['output'];
  sourceAccountId?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
};

/** Type of hotel contract payment categories */
export enum HotelContractPaymentCategory {
  ComissionPayment = 'ComissionPayment',
  CouponPayment = 'CouponPayment',
  HotelFinalPayment = 'HotelFinalPayment',
  NonRefundableDeposit = 'NonRefundableDeposit',
  NonRefundablePayment = 'NonRefundablePayment',
  RefundableDeposit = 'RefundableDeposit',
  TransactionFee = 'TransactionFee'
}

/** Status of Hotel Contracts */
export enum HotelContractStatus {
  Closed = 'Closed',
  InProgress = 'InProgress',
  RecoverCommission = 'RecoverCommission',
  ToPay = 'ToPay'
}

/** Hotel Image */
export type HotelImage = {
  __typename?: 'HotelImage';
  size?: Maybe<ImageSizeLabel>;
  url: Scalars['String']['output'];
};

/** Hotel image group */
export type HotelImageGroup = {
  __typename?: 'HotelImageGroup';
  hotelImageGroupableId: Scalars['String']['output'];
  hotelImageGroupableType: HotelImageGroupType;
  hotelImages?: Maybe<Array<Maybe<HotelImage>>>;
};


/** Hotel image group */
export type HotelImageGroupHotelImagesArgs = {
  size?: InputMaybe<ImageSizeLabel>;
};

export enum HotelImageGroupType {
  Hotel = 'Hotel',
  HotelRoom = 'HotelRoom'
}

/** Hotel patch */
export type HotelPatch = {
  address?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<HotelAmenityType>>;
  checkInTime?: InputMaybe<Scalars['String']['input']>;
  checkOutTime?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<CountryIso2Code>;
  expediaId?: InputMaybe<Scalars['String']['input']>;
  hotelTranslations?: InputMaybe<Array<HotelTranslationPatch>>;
  imageSource?: InputMaybe<SourceHotelRoom>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

/** Hotel room type */
export type HotelRoom = {
  __typename?: 'HotelRoom';
  amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bedTypeCombinationItems: Array<BedTypeCombinationItem>;
  hotelId: Scalars['String']['output'];
  hotelRoomTranslations?: Maybe<Array<HotelRoomTranslation>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupancy: Scalars['Int']['output'];
  roomSquareFeet?: Maybe<Scalars['Int']['output']>;
  roomSquareMeters?: Maybe<Scalars['Int']['output']>;
  /** if !source provider=revolugo */
  source?: Maybe<SourceHotelRoom>;
};

/** Represent an hotel room resource */
export type HotelRoomInput = {
  bedTypeCombinationItems: Array<BedTypeCombinationItemInput>;
  hotelRoomTranslations: Array<HotelRoomTranslationInput>;
  name: Scalars['String']['input'];
  roomSquareFeet?: InputMaybe<Scalars['Int']['input']>;
  roomSquareMeters?: InputMaybe<Scalars['Int']['input']>;
};

export enum HotelRoomOfferType {
  HotelRoom = 'HotelRoom',
  Package = 'Package'
}

export type HotelRoomResponseDto = {
  __typename?: 'HotelRoomResponseDto';
  amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  bedTypeCombinationItems: Array<BedTypeCombinationItem>;
  createdAt: Scalars['DateTimeISO']['output'];
  description: Scalars['String']['output'];
  hotelId: Scalars['String']['output'];
  hotelRoomTranslations?: Maybe<Array<HotelRoomTranslation>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  occupancy: Scalars['Int']['output'];
  roomSquareFeet?: Maybe<Scalars['Int']['output']>;
  roomSquareMeters?: Maybe<Scalars['Int']['output']>;
  /** if !source provider=revolugo */
  source?: Maybe<SourceHotelRoom>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Hotel room stock type */
export type HotelRoomStock = {
  __typename?: 'HotelRoomStock';
  breakfastOption?: Maybe<BreakfastOption>;
  breakfastRetrocommission?: Maybe<Scalars['Int']['output']>;
  breakfastUnitPrice?: Maybe<Scalars['Int']['output']>;
  checkInDate: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  eventScoped: Scalars['Boolean']['output'];
  events: Array<Event>;
  hotelContractId?: Maybe<Scalars['String']['output']>;
  hotelRoomId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  marginRate: Scalars['Float']['output'];
  minNightCount?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  releaseDate: Scalars['String']['output'];
  roomRetrocommission?: Maybe<Scalars['Int']['output']>;
};

/** Hotel Room Stock Booking */
export type HotelRoomStockBooking = {
  __typename?: 'HotelRoomStockBooking';
  breakfastOption?: Maybe<BreakfastOption>;
  breakfastUnitPrice?: Maybe<Scalars['Int']['output']>;
  checkInDate: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  currency: CurrencyGraphQl;
  hotelBookingId: Scalars['String']['output'];
  hotelContractId?: Maybe<Scalars['String']['output']>;
  hotelRoomId: Scalars['String']['output'];
  hotelRoomStock?: Maybe<HotelRoomStock>;
  hotelRoomStockId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  marginRate: Scalars['Float']['output'];
  minNightCount?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  releaseDate: Scalars['String']['output'];
  roomRetrocommission?: Maybe<Scalars['Int']['output']>;
};

/** Hotel room translation */
export type HotelRoomTranslation = {
  __typename?: 'HotelRoomTranslation';
  description?: Maybe<Scalars['String']['output']>;
  locale: Lang;
  name?: Maybe<Scalars['String']['output']>;
};

export type HotelRoomTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locale: Lang;
  name: Scalars['String']['input'];
};

/** Hotel rooming list */
export type HotelRoomingList = {
  __typename?: 'HotelRoomingList';
  hotelBookingId: Scalars['String']['output'];
  hotelRoom: HotelRoom;
  hotelRoomId: Scalars['String']['output'];
  hotelRoomingListGuests: Array<HotelRoomingListGuest>;
  id: Scalars['String']['output'];
};

/** Hotel rooming list guest */
export type HotelRoomingListGuest = {
  __typename?: 'HotelRoomingListGuest';
  fullname: Scalars['String']['output'];
  hotelRoomingListId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type HotelRoomingListGuestResponseDto = {
  __typename?: 'HotelRoomingListGuestResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  fullname: Scalars['String']['output'];
  hotelRoomingListId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type HotelRoomingListResponseDto = {
  __typename?: 'HotelRoomingListResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  hotelBookingId: Scalars['String']['output'];
  hotelRoom: HotelRoomResponseDto;
  hotelRoomId: Scalars['String']['output'];
  hotelRoomingListGuests: Array<HotelRoomingListGuestResponseDto>;
  id: Scalars['String']['output'];
  limitDate?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Hotel Selection */
export type HotelSelection = {
  __typename?: 'HotelSelection';
  hotels?: Maybe<Array<Hotel>>;
  id: Scalars['String']['output'];
  isPartner?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Hotel translation */
export type HotelTranslation = {
  __typename?: 'HotelTranslation';
  description?: Maybe<Scalars['String']['output']>;
  hotelId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locale: Lang;
  name: Scalars['String']['output'];
  policy?: Maybe<Scalars['String']['output']>;
};

export type HotelTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  hotelId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale: Lang;
  name: Scalars['String']['input'];
  policy?: InputMaybe<Scalars['String']['input']>;
};

/** Hotel Translation Patch */
export type HotelTranslationPatch = {
  description?: InputMaybe<Scalars['String']['input']>;
  hotelId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  locale: Lang;
  name?: InputMaybe<Scalars['String']['input']>;
  policy?: InputMaybe<Scalars['String']['input']>;
};

/** Update Hotel */
export type HotelUpdateInput = {
  id: Scalars['String']['input'];
  patch: HotelPatch;
};

export enum ImageSizeLabel {
  L = 'L',
  M = 'M',
  Original = 'ORIGINAL',
  S = 'S',
  Xl = 'XL',
  Xs = 'XS'
}

export type IndicatorPrices = {
  __typename?: 'IndicatorPrices';
  buyCurrency: CurrencyGraphQl;
  buyPrice: Scalars['Int']['output'];
  buyPriceEur: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  sellCurrency: CurrencyGraphQl;
  taxIncludedSellPrice: Scalars['Int']['output'];
  taxIncludedSellPriceEur: Scalars['Int']['output'];
};

/** Invoice type we get in booking */
export type Invoice = {
  __typename?: 'Invoice';
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>;
  type: AccountingDocumentType;
  url: Scalars['String']['output'];
};

export type InvoiceCommandInput = {
  customerId: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
};

export enum Lang {
  De = 'DE',
  En = 'EN',
  Es = 'ES',
  Fr = 'FR',
  It = 'IT',
  Nl = 'NL',
  Pt = 'PT'
}

export enum Locale {
  DeDe = 'de_DE',
  EnUs = 'en_US',
  EsEs = 'es_ES',
  FrFr = 'fr_FR',
  ItIt = 'it_IT',
  NlNl = 'nl_NL',
  PtPt = 'pt_PT'
}

/** type of LoyaltyRewardStatus */
export enum LoyaltyRewardStatus {
  None = 'None',
  Pending = 'Pending',
  Received = 'Received',
  Unknown = 'Unknown'
}

/** Map Marker */
export type MapMarker = {
  __typename?: 'MapMarker';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  markerPicture?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Mentions = {
  add: Array<Scalars['String']['input']>;
  remove: Array<Scalars['String']['input']>;
};

export type MoneyObject = {
  __typename?: 'MoneyObject';
  currency: CurrencyGraphQl;
  value: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  archiveComment: Scalars['String']['output'];
  associateTaxes: Scalars['Boolean']['output'];
  cancelBooking?: Maybe<Coupon>;
  confirmBooking: Scalars['Boolean']['output'];
  confirmPayLaterBooking: Scalars['Boolean']['output'];
  confirmPayment: Scalars['Boolean']['output'];
  copyHotelRoom: HotelRoom;
  createBookingGroup: Scalars['String']['output'];
  createComment: Scalars['String']['output'];
  createHotel: Scalars['String']['output'];
  createHotelContractFinancial: Scalars['String']['output'];
  createHotelRoom: HotelRoom;
  createHotelRoomingListGuest: Scalars['Boolean']['output'];
  createOrderItem: Scalars['String']['output'];
  createPayment: CreatePaymentResponseDto;
  createProduct: Scalars['String']['output'];
  createProductFile: Scalars['Boolean']['output'];
  createProductType: Scalars['String']['output'];
  createTax: Tax;
  deleteHotelContractFile: Scalars['Boolean']['output'];
  deleteHotelContractPayment: Scalars['Boolean']['output'];
  deleteHotelRoomingListGuest: Scalars['Boolean']['output'];
  deleteOrderItem: Scalars['Boolean']['output'];
  deletePayment: Scalars['Boolean']['output'];
  deleteProductFile: Scalars['Boolean']['output'];
  deleteSetting: Setting;
  deleteTax: Scalars['Boolean']['output'];
  deleteTaxAssociation: Scalars['Boolean']['output'];
  editBookingPrice: Scalars['Boolean']['output'];
  editHotelContractPayment: HotelContractPayment;
  editPayment: Scalars['Boolean']['output'];
  editProduct: Scalars['String']['output'];
  generateInvoice: Scalars['String']['output'];
  hotelContractCreate: HotelContract;
  hotelContractEditLoyaltyRewardStatus: HotelContract;
  linkBookings: Scalars['Boolean']['output'];
  readComment: Scalars['Boolean']['output'];
  reconfirmBooking: Scalars['Boolean']['output'];
  syncHotelContent: Scalars['Boolean']['output'];
  syncPayment: SyncPaymentResponse;
  unlinkBookings: Scalars['Boolean']['output'];
  updateBookingGroup: Scalars['Boolean']['output'];
  updateBookingVisibility: Scalars['Boolean']['output'];
  updateComment: Scalars['Boolean']['output'];
  updateGuests: Scalars['Boolean']['output'];
  updateHotel: Scalars['Boolean']['output'];
  updateHotelContractFinance: HotelContract;
  updateHotelContractFinancial: Scalars['String']['output'];
  updateHotelContractName: HotelContract;
  updateHotelContractStatus: HotelContract;
  updateHotelRoom: HotelRoom;
  updateHotelRoomingListGuest: Scalars['Boolean']['output'];
  updateOwner: HotelContract;
  updateRoomStockRanges: Scalars['Boolean']['output'];
  updateTax: Scalars['Boolean']['output'];
  uploadHotelContractFiles: Array<GraphFileUploadStatus>;
  uploadHotelImages: Array<ResultUploadImage>;
  uploadHotelRoomImages: Array<ResultUploadImage>;
  upsertSetting: Setting;
};


export type MutationArchiveCommentArgs = {
  input: ArchiveCommentInput;
};


export type MutationAssociateTaxesArgs = {
  taxIds: Array<Scalars['String']['input']>;
  taxableIds: Array<Scalars['String']['input']>;
};


export type MutationCancelBookingArgs = {
  payload: CreateCouponInput;
};


export type MutationConfirmBookingArgs = {
  input: ConfirmBookingInput;
};


export type MutationConfirmPayLaterBookingArgs = {
  input: ConfirmBookingInput;
};


export type MutationConfirmPaymentArgs = {
  input: ConfirmPaymentInput;
};


export type MutationCopyHotelRoomArgs = {
  hotelRoomId: Scalars['String']['input'];
};


export type MutationCreateBookingGroupArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateHotelArgs = {
  input: CreateHotelInput;
};


export type MutationCreateHotelContractFinancialArgs = {
  input: CreateHotelContractFinancialInput;
};


export type MutationCreateHotelRoomArgs = {
  hotelId: Scalars['String']['input'];
  payload: HotelRoomInput;
};


export type MutationCreateHotelRoomingListGuestArgs = {
  fullname: Scalars['String']['input'];
  hotelRoomingListId: Scalars['String']['input'];
};


export type MutationCreateOrderItemArgs = {
  input: CreateOrderItemInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateProductArgs = {
  input: CreateProductInput;
};


export type MutationCreateProductFileArgs = {
  input: CreateProductFileInput;
};


export type MutationCreateProductTypeArgs = {
  input: CreateProductTypeInput;
};


export type MutationCreateTaxArgs = {
  input: CreateTaxInput;
};


export type MutationDeleteHotelContractFileArgs = {
  hotelContractId: Scalars['String']['input'];
  recordId: Scalars['String']['input'];
};


export type MutationDeleteHotelContractPaymentArgs = {
  payload: DeleteHotelContractPaymentInput;
};


export type MutationDeleteHotelRoomingListGuestArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOrderItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeletePaymentArgs = {
  input: DeletePaymentInput;
};


export type MutationDeleteProductFileArgs = {
  input: DeleteProductFileInput;
};


export type MutationDeleteSettingArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTaxArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteTaxAssociationArgs = {
  taxableId: Scalars['String']['input'];
};


export type MutationEditBookingPriceArgs = {
  amount: Scalars['Int']['input'];
  bookingId: Scalars['String']['input'];
};


export type MutationEditHotelContractPaymentArgs = {
  payload: EditHotelContractPaymentInput;
};


export type MutationEditPaymentArgs = {
  input: EditPaymentInput;
};


export type MutationEditProductArgs = {
  input: EditProductInput;
};


export type MutationGenerateInvoiceArgs = {
  input: InvoiceCommandInput;
};


export type MutationHotelContractCreateArgs = {
  input: CreateHotelContractInput;
};


export type MutationHotelContractEditLoyaltyRewardStatusArgs = {
  input: EditLoyaltyRewardStatus;
};


export type MutationLinkBookingsArgs = {
  bookingGroupId: Scalars['String']['input'];
  bookingIds: Array<Scalars['String']['input']>;
};


export type MutationReadCommentArgs = {
  input: ReadCommentInput;
};


export type MutationReconfirmBookingArgs = {
  bookingId: Scalars['String']['input'];
};


export type MutationSyncHotelContentArgs = {
  id: Scalars['String']['input'];
};


export type MutationSyncPaymentArgs = {
  input: SyncPaymentInput;
};


export type MutationUnlinkBookingsArgs = {
  bookingGroupId: Scalars['String']['input'];
  bookingIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateBookingGroupArgs = {
  input: UpdateBookingGroupInput;
};


export type MutationUpdateBookingVisibilityArgs = {
  input: SetBookingVisibilityInput;
};


export type MutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type MutationUpdateGuestsArgs = {
  input: UpdateGuestsInput;
};


export type MutationUpdateHotelArgs = {
  input: HotelUpdateInput;
};


export type MutationUpdateHotelContractFinanceArgs = {
  payload: UpdateHotelContractFinanceInput;
};


export type MutationUpdateHotelContractFinancialArgs = {
  input: UpdateHotelContractFinancialInput;
};


export type MutationUpdateHotelContractNameArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateHotelContractStatusArgs = {
  payload: UpdateHotelContractStatusInput;
};


export type MutationUpdateHotelRoomArgs = {
  id: Scalars['String']['input'];
  payload: HotelRoomInput;
};


export type MutationUpdateHotelRoomingListGuestArgs = {
  fullname: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationUpdateOwnerArgs = {
  payload: UpdateHotelContractOwnerInput;
};


export type MutationUpdateRoomStockRangesArgs = {
  data: RoomStockRangeArrayInput;
};


export type MutationUpdateTaxArgs = {
  input: UpdateTaxInput;
};


export type MutationUploadHotelContractFilesArgs = {
  payload: HotelContractFileUploadInput;
};


export type MutationUploadHotelImagesArgs = {
  files: Array<Scalars['File']['input']>;
  hotelId: Scalars['String']['input'];
};


export type MutationUploadHotelRoomImagesArgs = {
  files: Array<Scalars['File']['input']>;
  hotelId: Scalars['String']['input'];
  hotelRoomId: Scalars['String']['input'];
};


export type MutationUpsertSettingArgs = {
  setting: UpsertSettingInput;
};

/** Order direction */
export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum OrderItemStatus {
  Cancelled = 'Cancelled',
  Confirmed = 'Confirmed',
  Pending = 'Pending'
}

export type OrderItemsResponseDto = {
  __typename?: 'OrderItemsResponseDto';
  count: Scalars['Int']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  product: ProductResponseDto;
  productId: Scalars['String']['output'];
  status: OrderItemStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Organization */
export type Organization = {
  __typename?: 'Organization';
  bankAccountAdditionalData?: Maybe<Scalars['String']['output']>;
  bankAccountIban?: Maybe<Scalars['String']['output']>;
  bankAccountName?: Maybe<Scalars['String']['output']>;
  billingAddressCity?: Maybe<Scalars['String']['output']>;
  billingAddressCountry?: Maybe<Scalars['String']['output']>;
  billingAddressLine1?: Maybe<Scalars['String']['output']>;
  billingAddressState?: Maybe<Scalars['String']['output']>;
  billingAddressZip?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  domainUrl?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  events: Array<Maybe<Event>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  taxNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum PackageType {
  BestMatch = 'BestMatch',
  Cheapest = 'Cheapest',
  MatchingRoomCount = 'MatchingRoomCount',
  Regular = 'Regular'
}

export type PaginatedBookingGroup = {
  __typename?: 'PaginatedBookingGroup';
  edges: Array<BookingGroupEdge>;
  pageInfo: GraphQlPaginationPageInfo;
};

export type PaginatedBookingGroupResponseDto = {
  __typename?: 'PaginatedBookingGroupResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  customerName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type PaginatedHotelContracts = {
  __typename?: 'PaginatedHotelContracts';
  edges: Array<HotelContractEdge>;
  pageInfo: GraphQlPaginationPageInfo;
};

export type PaginatedTax = {
  __typename?: 'PaginatedTax';
  edges: Array<TaxEdge>;
  pageInfo: GraphQlPaginationPageInfo;
};

export type PaginatedTaxResponseDto = {
  __typename?: 'PaginatedTaxResponseDto';
  amount?: Maybe<MoneyObject>;
  currency?: Maybe<CurrencyGraphQl>;
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  taxFrequency: TaxFrequency;
  taxMode: TaxMode;
};

/** Type of payLaterStatus */
export enum PayLaterStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
  Forced = 'Forced'
}

/** payment graphql type */
export type Payment = {
  __typename?: 'Payment';
  actualExchangeRate?: Maybe<Scalars['Float']['output']>;
  amount: Scalars['Float']['output'];
  bankTransferPayment?: Maybe<BankTransfer>;
  category?: Maybe<PaymentCategory>;
  couponPayment?: Maybe<CouponPayment>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyGraphQl;
  currencyRateId?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTimeISO']['output']>;
  paymentMethod: PaymentMethod;
  paymentStatus: PaymentStatus;
  paymentType: PaymentType;
  reason?: Maybe<PaymentCategory>;
  remarks?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  stripePaymentIntentPayment?: Maybe<StripePaymentIntentPayment>;
};

/** Kind of payment */
export enum PaymentAssociationResourceType {
  Booking = 'Booking',
  BookingGroup = 'BookingGroup',
  HotelContract = 'HotelContract',
  Organization = 'Organization'
}

export type PaymentBalanceResponse = {
  __typename?: 'PaymentBalanceResponse';
  charge: AmountObjectType;
  currency: CurrencyGraphQl;
  paidAt?: Maybe<Scalars['DateTimeISO']['output']>;
  payments: Array<Payment>;
  refund: AmountObjectType;
};

/** Describe categories a payment can have */
export enum PaymentCategory {
  BookingCanceledPenalty = 'BookingCanceledPenalty',
  ComissionPayment = 'ComissionPayment',
  Commission = 'Commission',
  CouponPayment = 'CouponPayment',
  DepositAccountCredit = 'DepositAccountCredit',
  Fee = 'Fee',
  HotelFinalPayment = 'HotelFinalPayment',
  NonRefundableDeposit = 'NonRefundableDeposit',
  NonRefundablePayment = 'NonRefundablePayment',
  OngoingBooking = 'OngoingBooking',
  Payment = 'Payment',
  Refund = 'Refund',
  RefundableDeposit = 'RefundableDeposit',
  TransactionFee = 'TransactionFee'
}

/** Describe different payment method name */
export enum PaymentMethod {
  BankTransfer = 'BankTransfer',
  BankTransferLegacy = 'BankTransferLegacy',
  Coupon = 'Coupon',
  CouponLegacy = 'CouponLegacy',
  CreditCard = 'CreditCard',
  DepositAccount = 'DepositAccount',
  StripeLegacy = 'StripeLegacy'
}

export enum PaymentProvider {
  IbanFirst = 'IbanFirst',
  Qonto = 'Qonto',
  Stripe = 'Stripe'
}

export type PaymentResponseDto = {
  __typename?: 'PaymentResponseDto';
  actualExchangeRate?: Maybe<Scalars['Float']['output']>;
  amount: Scalars['Float']['output'];
  bankTransferPayment?: Maybe<BankTransfer>;
  category?: Maybe<PaymentCategory>;
  couponPayment?: Maybe<CouponPayment>;
  createdAt: Scalars['DateTimeISO']['output'];
  currency: CurrencyGraphQl;
  currencyRateId?: Maybe<Scalars['String']['output']>;
  dueAt?: Maybe<Scalars['DateTimeISO']['output']>;
  fee?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paidAt?: Maybe<Scalars['DateTimeISO']['output']>;
  paymentMethod: PaymentMethod;
  paymentStatus: PaymentStatus;
  paymentType: PaymentType;
  reason?: Maybe<PaymentCategory>;
  remarks?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  resourceType: PaymentAssociationResourceType;
  stripePaymentIntentPayment?: Maybe<StripePaymentIntentPayment>;
};

/** Describe status of the payment */
export enum PaymentStatus {
  Canceled = 'Canceled',
  Confirmed = 'Confirmed',
  Created = 'Created',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Pending = 'Pending'
}

/** Describe different payment types */
export enum PaymentType {
  Credit = 'Credit',
  Debit = 'Debit'
}

/** Describe the operation we need to do with this model */
export enum PersistenceAction {
  Create = 'Create',
  Delete = 'Delete',
  Update = 'Update'
}

export type ProductResponseDto = {
  __typename?: 'ProductResponseDto';
  buyActualExchangeRate?: Maybe<Scalars['Float']['output']>;
  buyCurrency?: Maybe<CurrencyGraphQl>;
  buyPrice: Scalars['Int']['output'];
  buyPriceEur: Scalars['Int']['output'];
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  endDate?: Maybe<Scalars['DateTimeISO']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productTypeId: Scalars['String']['output'];
  remarks?: Maybe<Scalars['String']['output']>;
  sellCurrency?: Maybe<CurrencyGraphQl>;
  sellPrice: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTimeISO']['output']>;
  taxIncludedSellPrice: Scalars['Int']['output'];
  type: ProductTypeResponseDto;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export enum ProductTypePriority {
  High = 'High',
  Low = 'Low'
}

export type ProductTypeResponseDto = {
  __typename?: 'ProductTypeResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type ProductTypesResponseDto = {
  __typename?: 'ProductTypesResponseDto';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  priority: ProductTypePriority;
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Describe all providers */
export enum Provider {
  Rakuten = 'Rakuten',
  Revolugo = 'Revolugo'
}

export type Query = {
  __typename?: 'Query';
  bedType: BedType;
  bedTypes?: Maybe<Array<Maybe<BedType>>>;
  booking: Booking;
  bookingGroup: BookingGroupResponseDto;
  bookingGroupsPaginated: PaginatedBookingGroup;
  bookings: Array<Booking>;
  bookingsPaginated: GetBookingsPaginatedResponseDto;
  bookingsWithOrganizationId: Array<Booking>;
  comments: Array<CommentResponseDto>;
  currentUser: User;
  customer: Customer;
  customers: Array<Maybe<Customer>>;
  document: DocumentResponseDto;
  documents: Array<DocumentResponseDto>;
  eventById: Event;
  events: Array<Maybe<Event>>;
  eventsByOrga: Array<Maybe<Event>>;
  expediaHotel: GraphQlExpediaHotel;
  getCustomerById: CustomerResponseDto;
  getPaymentByResourceId: Array<PaymentResponseDto>;
  hotel: Hotel;
  hotelBooking: HotelBooking;
  hotelContract: HotelContract;
  hotelContracts: Array<Maybe<HotelContract>>;
  hotelContractsPaginated: PaginatedHotelContracts;
  hotelImageGroups?: Maybe<Array<Maybe<HotelImageGroup>>>;
  hotelRoom: HotelRoom;
  hotelRoomingLists: Array<HotelRoomingListResponseDto>;
  hotelRooms: Array<Maybe<HotelRoom>>;
  hotels: Array<Maybe<Hotel>>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  orderItems: Array<OrderItemsResponseDto>;
  organization: Organization;
  organizations: Array<Maybe<Organization>>;
  payment: Payment;
  paymentBalance: PaymentBalanceResponse;
  paymentsWithBookingId: Array<Payment>;
  productFiles: Array<FileResponseDto>;
  productTypes: Array<ProductTypesResponseDto>;
  rawModel: RawModel;
  rawModels: Array<RawModel>;
  rawModelsByIds: Array<RawModel>;
  roomStockRanges: Array<RoomStockRange>;
  roomTypeByName: Array<Maybe<RoomType>>;
  searchCustomer: Array<CustomerResponseDto>;
  setting: Setting;
  settingsByOrga: Array<Setting>;
  settingsByQuery: Array<Setting>;
  settingsBySettingableId: Array<Setting>;
  settingsBySlug?: Maybe<Setting>;
  slugExists?: Maybe<Setting>;
  tags: Array<Maybe<Tag>>;
  tax: Tax;
  taxes: Array<Tax>;
  taxesPaginated: PaginatedTax;
  users: Array<User>;
};


export type QueryBedTypeArgs = {
  id: Scalars['String']['input'];
};


export type QueryBedTypesArgs = {
  name: Scalars['String']['input'];
};


export type QueryBookingArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookingGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryBookingGroupsPaginatedArgs = {
  options?: InputMaybe<GetBookingGroupsPaginatedArgs>;
};


export type QueryBookingsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookingsPaginatedArgs = {
  options?: InputMaybe<GetBookingsPaginatedOptions>;
};


export type QueryBookingsWithOrganizationIdArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryCommentsArgs = {
  commentableId: Scalars['String']['input'];
  commentableType: CommentableType;
};


export type QueryCustomerArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomersArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['String']['input'];
};


export type QueryDocumentsArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
};


export type QueryEventByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryEventsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEventsByOrgaArgs = {
  organizationId: Scalars['String']['input'];
};


export type QueryExpediaHotelArgs = {
  expediaId: Scalars['String']['input'];
};


export type QueryGetCustomerByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPaymentByResourceIdArgs = {
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
};


export type QueryHotelArgs = {
  id: Scalars['String']['input'];
};


export type QueryHotelBookingArgs = {
  bookingId: Scalars['String']['input'];
};


export type QueryHotelContractArgs = {
  id: Scalars['String']['input'];
};


export type QueryHotelContractsArgs = {
  payload?: InputMaybe<GetHotelContractsInput>;
};


export type QueryHotelContractsPaginatedArgs = {
  options?: InputMaybe<GetHotelContractsPaginatedInput>;
};


export type QueryHotelImageGroupsArgs = {
  resourceId: Scalars['String']['input'];
};


export type QueryHotelRoomArgs = {
  id: Scalars['String']['input'];
};


export type QueryHotelRoomingListsArgs = {
  bookingId: Scalars['String']['input'];
};


export type QueryHotelRoomsArgs = {
  hotelId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryHotelsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoicesArgs = {
  resourceId: Scalars['String']['input'];
};


export type QueryOrderItemsArgs = {
  orderId: Scalars['String']['input'];
};


export type QueryOrganizationArgs = {
  id: Scalars['String']['input'];
};


export type QueryOrganizationsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPaymentArgs = {
  id: Scalars['String']['input'];
};


export type QueryPaymentBalanceArgs = {
  chargeId: Scalars['String']['input'];
  paymentProvider: PaymentProvider;
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
};


export type QueryPaymentsWithBookingIdArgs = {
  bookingId: Scalars['String']['input'];
};


export type QueryProductFilesArgs = {
  resourceId: Scalars['String']['input'];
};


export type QueryProductTypesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRawModelArgs = {
  id: Scalars['String']['input'];
  type: RawModelType;
};


export type QueryRawModelsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDesc?: InputMaybe<Scalars['Boolean']['input']>;
  type: RawModelType;
};


export type QueryRawModelsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
  type: RawModelType;
};


export type QueryRoomStockRangesArgs = {
  filterByCheckInDate?: InputMaybe<Scalars['String']['input']>;
  hotelId: Scalars['String']['input'];
  hotelRoomIds: Array<Scalars['String']['input']>;
};


export type QueryRoomTypeByNameArgs = {
  name: Scalars['String']['input'];
};


export type QuerySearchCustomerArgs = {
  query: Scalars['String']['input'];
};


export type QuerySettingArgs = {
  id: Scalars['String']['input'];
};


export type QuerySettingsByOrgaArgs = {
  organizationId: Scalars['String']['input'];
};


export type QuerySettingsByQueryArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySettingsBySettingableIdArgs = {
  settingableId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySettingsBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QuerySlugExistsArgs = {
  organizationId: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};


export type QueryTagsArgs = {
  name: Scalars['String']['input'];
};


export type QueryTaxArgs = {
  id: Scalars['String']['input'];
};


export type QueryTaxesArgs = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTaxesPaginatedArgs = {
  options?: InputMaybe<GetTaxesPaginatedOptions>;
};


export type QueryUsersArgs = {
  name: Scalars['String']['input'];
};

export type RawModel = {
  __typename?: 'RawModel';
  data: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/** Type of model */
export enum RawModelType {
  Booking = 'Booking',
  Customer = 'Customer',
  Event = 'Event',
  Hotel = 'Hotel',
  HotelContract = 'HotelContract',
  Organization = 'Organization',
  Setting = 'Setting'
}

export type ReadCommentInput = {
  commentId: Scalars['String']['input'];
  seenAt: Scalars['DateTimeISO']['input'];
};

/** type of ActiveStorageAttachment recordType */
export enum RecordType {
  HotelContractFile = 'HotelContractFile',
  MapMarker = 'MapMarker',
  Product = 'Product',
  Widget = 'Widget'
}

export type ResultUploadImage = {
  __typename?: 'ResultUploadImage';
  name: Scalars['String']['output'];
  urls: Array<Scalars['String']['output']>;
};

/** room stock graphql type */
export type RoomStock = {
  __typename?: 'RoomStock';
  booked: Scalars['Int']['output'];
  breakfastOption: BreakfastOption;
  breakfastPrice?: Maybe<Scalars['Int']['output']>;
  checkInDate: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  marginRate: Scalars['Float']['output'];
  minStay: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  roomRetrocommission: Scalars['Int']['output'];
  status?: Maybe<PersistenceAction>;
};

export type RoomStockInput = {
  booked: Scalars['Int']['input'];
  breakfastOption: BreakfastOption;
  breakfastPrice?: InputMaybe<Scalars['Int']['input']>;
  checkInDate: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  marginRate: Scalars['Float']['input'];
  minStay: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  roomRetrocommission: Scalars['Int']['input'];
  status?: InputMaybe<PersistenceAction>;
};

/** hotel room stock range type */
export type RoomStockRange = {
  __typename?: 'RoomStockRange';
  breakfastOption: BreakfastOption;
  cancellationPolicies: Array<CancellationPolicy>;
  createdAt?: Maybe<Scalars['String']['output']>;
  currency: CurrencyGraphQl;
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  days: Array<RoomStock>;
  eventScoped: Scalars['Boolean']['output'];
  events: Array<Event>;
  hotelContractId: Scalars['String']['output'];
  hotelId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  releaseDate: Scalars['String']['output'];
  remainingCount: Scalars['Int']['output'];
  resourceId: Scalars['String']['output'];
  tags: Array<Tag>;
  warnings?: Maybe<Warnings>;
};

export type RoomStockRangeArrayInput = {
  range: Array<RoomStockRangeInput>;
};

export type RoomStockRangeInput = {
  breakfastOption: BreakfastOption;
  cancellationPolicies: Array<CancellationPolicyInput>;
  currency: CurrencyGraphQl;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  eventScoped: Scalars['Boolean']['input'];
  events: Array<EventInput>;
  hotelContractId: Scalars['String']['input'];
  hotelContractName: Scalars['String']['input'];
  hotelId: Scalars['String']['input'];
  hotelRoomId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  releaseDate: Scalars['String']['input'];
  stocks: Array<RoomStockInput>;
  tags: Array<TagInput>;
};

/** Room type */
export type RoomType = {
  __typename?: 'RoomType';
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export enum RoomingListStatus {
  Complete = 'Complete',
  Pending = 'Pending'
}

export enum SelectedHotelAction {
  Add = 'Add',
  Remove = 'Remove'
}

/** Change the booking visibility */
export type SetBookingVisibilityInput = {
  id: Scalars['String']['input'];
  visibility: BookingVisibility;
};

/** Setting */
export type Setting = {
  __typename?: 'Setting';
  colorHotelMarkerPrimary?: Maybe<Scalars['String']['output']>;
  colorHotelMarkerSecondary?: Maybe<Scalars['String']['output']>;
  colorPrimary?: Maybe<Scalars['String']['output']>;
  colorSecondary?: Maybe<Scalars['String']['output']>;
  hideAddressAutocompleteInput?: Maybe<Scalars['Boolean']['output']>;
  hideHotline?: Maybe<Scalars['Boolean']['output']>;
  hotelMaxCount?: Maybe<Scalars['Float']['output']>;
  hotelRadius?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isHotelSelectionRestricted: Scalars['Boolean']['output'];
  mapMarkers?: Maybe<Array<MapMarker>>;
  name: Scalars['String']['output'];
  organizationId: Scalars['String']['output'];
  parent?: Maybe<Setting>;
  parentId?: Maybe<Scalars['String']['output']>;
  payLaterAmount?: Maybe<Scalars['Float']['output']>;
  payLaterStatus?: Maybe<PayLaterStatus>;
  priceMultiplier?: Maybe<Scalars['Float']['output']>;
  providers?: Maybe<Array<Provider>>;
  quoteRequestBooking?: Maybe<Scalars['Boolean']['output']>;
  revolugoOffersHighlight?: Maybe<Scalars['Boolean']['output']>;
  settingHotelSelections?: Maybe<Array<SettingHotelSelection>>;
  settingSelectedHotels?: Maybe<Array<SettingSelectedHotel>>;
  settingableId?: Maybe<Scalars['String']['output']>;
  settingableType?: Maybe<SettingableType>;
  slug: Scalars['String']['output'];
};

/** Setting Hotel Selection */
export type SettingHotelSelection = {
  __typename?: 'SettingHotelSelection';
  action: SelectedHotelAction;
  hotelSelection: HotelSelection;
  hotelSelectionId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  settingId: Scalars['String']['output'];
};

/** Setting Selected Hotel */
export type SettingSelectedHotel = {
  __typename?: 'SettingSelectedHotel';
  action: SelectedHotelAction;
  hotel?: Maybe<Hotel>;
  hotelId: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  isPartner?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  settingId: Scalars['String']['output'];
};

/** Settingable type: EVENT or ORGANIZATION */
export enum SettingableType {
  Event = 'Event',
  Organization = 'Organization'
}

/** Source hotel room */
export enum SourceHotelRoom {
  Expedia = 'Expedia',
  Rakuten = 'Rakuten',
  Revolugo = 'Revolugo'
}

/** stripe payment intent payment graphql type */
export type StripePaymentIntentPayment = {
  __typename?: 'StripePaymentIntentPayment';
  id: Scalars['String']['output'];
  paymentId: Scalars['String']['output'];
  stripePaymentIntentId: Scalars['String']['output'];
};

/** Sync Credit Card Payment */
export type SyncPaymentInput = {
  amount: Scalars['Int']['input'];
  amountEuro: Scalars['Int']['input'];
  currency: CurrencyGraphQl;
  paymentCategory?: InputMaybe<HotelContractPaymentCategory>;
  paymentMethod: PaymentMethod;
  paymentProvider: PaymentProvider;
  paymentType: PaymentType;
  resourceId: Scalars['String']['input'];
  resourceType: PaymentAssociationResourceType;
  sourceId: Scalars['String']['input'];
};

/** Sync Payment Response */
export type SyncPaymentResponse = {
  __typename?: 'SyncPaymentResponse';
  paymentIds: Array<Scalars['String']['output']>;
};

/** Tag */
export type Tag = {
  __typename?: 'Tag';
  bg?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  faIcon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  taggingsCount: Scalars['Int']['output'];
};

/** Tag graphql input type */
export type TagInput = {
  bg?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  faIcon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  taggingsCount?: InputMaybe<Scalars['Int']['input']>;
};

export type Tax = {
  __typename?: 'Tax';
  amount?: Maybe<MoneyObject>;
  currency?: Maybe<CurrencyGraphQl>;
  dateFrom: Scalars['String']['output'];
  dateTo: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hotels?: Maybe<Array<Hotel>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  taxFrequency: TaxFrequency;
  taxMode: TaxMode;
};

export type TaxEdge = {
  __typename?: 'TaxEdge';
  cursor: Scalars['String']['output'];
  node: PaginatedTaxResponseDto;
};

export enum TaxFrequency {
  PerNight = 'PerNight',
  PerStay = 'PerStay'
}

export enum TaxMode {
  PerAdult = 'PerAdult',
  PerBooking = 'PerBooking'
}

/** Update Booking Group */
export type UpdateBookingGroupInput = {
  id: Scalars['String']['input'];
  patch: UpdateBookingGroupPatch;
};

export type UpdateBookingGroupPatch = {
  customerId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
};

/** Update comment input */
export type UpdateCommentInput = {
  id: Scalars['String']['input'];
  patch: CommentPatch;
};

export type UpdateGuestsInput = {
  bookingId: Scalars['String']['input'];
  hotelRoomingLists: Array<UpdateHotelRoomingListsInput>;
};

/** Update HotelContract Finance informations */
export type UpdateHotelContractFinanceInput = {
  forcedTotalComissionsAmount?: InputMaybe<Scalars['Int']['input']>;
  forcedTotalPurchasedAmount?: InputMaybe<Scalars['Int']['input']>;
  forcedTotalVatComissionsAmount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateHotelContractFinancialInput = {
  id: Scalars['String']['input'];
  patch: UpdateHotelContractFinancialPatch;
};

export type UpdateHotelContractFinancialPatch = {
  comissionsAmount?: InputMaybe<Scalars['Float']['input']>;
  purchasedAmount?: InputMaybe<Scalars['Float']['input']>;
  vatComissionsAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** Update HotelContract owner */
export type UpdateHotelContractOwnerInput = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** Update HotelContract status */
export type UpdateHotelContractStatusInput = {
  id: Scalars['String']['input'];
  status: HotelContractStatus;
};

export type UpdateHotelEvent = {
  __typename?: 'UpdateHotelEvent';
  createdAt: Scalars['DateTimeISO']['output'];
  hotelId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  priority: UpdateHotelEventPriority;
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>;
};

/** Type of UpdateHotelEventPriority */
export enum UpdateHotelEventPriority {
  Error = 'ERROR',
  High = 'HIGH',
  Low = 'LOW',
  Normal = 'NORMAL'
}

export type UpdateHotelRoomingListsInput = {
  guests: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateTaxInput = {
  id: Scalars['String']['input'];
  patch: CreateTaxInput;
};

/** Upsert Setting Input */
export type UpsertSettingInput = {
  colorHotelMarkerPrimary?: InputMaybe<Scalars['String']['input']>;
  colorHotelMarkerSecondary?: InputMaybe<Scalars['String']['input']>;
  colorPrimary?: InputMaybe<Scalars['String']['input']>;
  colorSecondary?: InputMaybe<Scalars['String']['input']>;
  hideAddressAutocompleteInput?: InputMaybe<Scalars['Boolean']['input']>;
  hideHotline?: InputMaybe<Scalars['Boolean']['input']>;
  hotelMaxCount?: InputMaybe<Scalars['Float']['input']>;
  hotelRadius?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isHotelSelectionRestricted?: Scalars['Boolean']['input'];
  mapMarkers?: InputMaybe<Array<UpsertSettingMapMarkerInput>>;
  name: Scalars['String']['input'];
  organizationId: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
  payLaterAmount?: InputMaybe<Scalars['Float']['input']>;
  payLaterStatus: PayLaterStatus;
  priceMultiplier?: InputMaybe<Scalars['Float']['input']>;
  providers?: InputMaybe<Array<Provider>>;
  quoteRequestBooking?: InputMaybe<Scalars['Boolean']['input']>;
  revolugoOffersHighlight?: InputMaybe<Scalars['Boolean']['input']>;
  settingSelectedHotels?: InputMaybe<Array<UpsertSettingSelectedHotelsInput>>;
  settingableId: Scalars['String']['input'];
  settingableType: SettingableType;
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Upsert SettingMapMarker Input */
export type UpsertSettingMapMarkerInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  mapMarkerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** Upsert setting hotel selection */
export type UpsertSettingSelectedHotelsInput = {
  action: SelectedHotelAction;
  hotelId: Scalars['String']['input'];
  isPartner?: InputMaybe<Scalars['Boolean']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** User */
export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstname?: Maybe<Scalars['String']['output']>;
  fullname: Scalars['String']['output'];
  id: Scalars['String']['output'];
  initials: Scalars['String']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  notificationUserToken?: Maybe<Scalars['String']['output']>;
};

/** warning graphql type */
export type Warning = {
  __typename?: 'Warning';
  data: Array<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/** warnings graphql type */
export type Warnings = {
  __typename?: 'Warnings';
  cancellationPolicies?: Maybe<Warning>;
  releaseDate?: Maybe<Warning>;
};
